import * as fromDatatype from '../datatype-library/index';

export interface bl_crm_pricing_scheme_item_point_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  pricing_scheme_guid: fromDatatype.GuidDataFieldInterface;
  fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  fi_item_line_guid: fromDatatype.GuidDataFieldInterface;
  point_ccy_guid: fromDatatype.GuidDataFieldInterface;
  reward_type: fromDatatype.VarcharDatatypeInterface;
  redeem_type: fromDatatype.VarcharDatatypeInterface;
  reward_multiply_rule: fromDatatype.VarcharDatatypeInterface;
  reward_abs_rule: fromDatatype.VarcharDatatypeInterface;
  redeem_multiply_rule: fromDatatype.VarcharDatatypeInterface;
  redeem_abs_rule: fromDatatype.VarcharDatatypeInterface;
  reward_abs_amount: fromDatatype.BigIntegerDatatypeInterface;
  reward_multiply_ratio: fromDatatype.BigIntegerDatatypeInterface;
  redeem_abs_amount: fromDatatype.BigIntegerDatatypeInterface;
  redeem_multiply_ratio: fromDatatype.BigIntegerDatatypeInterface;
  reward_point: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_crm_pricing_scheme_item_point_link_RowClass
  implements bl_crm_pricing_scheme_item_point_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    pricing_scheme_guid: fromDatatype.GuidDataFieldInterface;
    fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
    fi_item_line_guid: fromDatatype.GuidDataFieldInterface;
    point_ccy_guid: fromDatatype.GuidDataFieldInterface;
    reward_type: fromDatatype.VarcharDatatypeInterface;
    redeem_type: fromDatatype.VarcharDatatypeInterface;
    reward_multiply_rule: fromDatatype.VarcharDatatypeInterface;
    reward_abs_rule: fromDatatype.VarcharDatatypeInterface;
    redeem_multiply_rule: fromDatatype.VarcharDatatypeInterface;
    redeem_abs_rule: fromDatatype.VarcharDatatypeInterface;
    reward_abs_amount: fromDatatype.BigIntegerDatatypeInterface;
    reward_multiply_ratio: fromDatatype.BigIntegerDatatypeInterface;
    redeem_abs_amount: fromDatatype.BigIntegerDatatypeInterface;
    redeem_multiply_ratio: fromDatatype.BigIntegerDatatypeInterface;
    reward_point: fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
  }
